import React from "react";
import { useDispatch, useSelector } from "react-redux";
import "./HeaderNav.scss";
import { useNavigate, useParams } from "react-router-dom";
import { List, Armchair, HandPlatter } from "lucide-react";

const HeaderNavPage = ({ title = "spice", onMenuClick }) => {
  const { restaurant, id, table } = useParams();
  const user = useSelector((state) => state?.user.user);
  const navigate = useNavigate();
  let allInfo = {};
  let parsedUserInfo = {};

  try {
    allInfo = JSON.parse(localStorage.getItem("allInfo") || "{}");
    parsedUserInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  } catch (err) {
    console.error("Error parsing storage in HeaderNav:", err);
  }

  // Display priority: URL param -> Stored userInfo -> Redux user
  const hasActiveSession = Boolean(
    allInfo?.tableOtp && allInfo?.isActive !== false,
  );
  const displayTable = hasActiveSession
    ? allInfo?.tableNumber || parsedUserInfo?.tableNumber || user?.tableNumber
    : table || parsedUserInfo?.tableNumber || user?.tableNumber;

  console.log("header user", user);
  console.log("header allInfo", allInfo);
  return (
    <header className="app-header">
      <button className="menu-btn" onClick={onMenuClick}>
        <List size={20} className="sidebar-icon" stroke="var(--text-color)" />
      </button>

      <h2 className="header-title">{restaurant || title}</h2>

      {user && (
        <div className="header-right">
          {/* Table Number Chip */}

          {displayTable && (
            <span className="table-chip">
              <Armchair
                size={13}
                className="sidebar-icon"
                stroke="var(--table-chip-color)"
              />
              T-{displayTable}
            </span>
          )}

          {allInfo?.tableOtp && (
            <span className="seat-chip">
              <HandPlatter
                size={13}
                className="sidebar-icon"
                stroke="var(--seat-chip-color)"
              />
              OTP: {allInfo?.tableOtp}
            </span>
          )}
        </div>
      )}
    </header>
  );
};

export default HeaderNavPage;
